import { useStyles } from './SearchRanking.styles'
import EmptyProductListing from '../../common/images/EmptyProductListing.png'
import { useCallback, useEffect, useState } from 'react'
import {
  LoadingTypes,
  getUrlPrefix,
  isLoading as Loading,
  serviceEnvironment,
} from '@labrav/common'
import {
  ButtonV2,
  LoadingLogo,
  ModalConfirmV2,
  ModalSizeVariants,
  SidePanelInfo,
} from '@labrav/react-components'
import { useDispatch, useSelector } from '../../store'
import {
  generateContentAi,
  getCompetitors,
  getKeywords,
  getSelfListingUrl,
  searchRanking,
} from '../../modules/mpsSeo/action'
import { useSeoAccountId } from './seoCloud'
import { KeywordItem } from '../../modules/mpsSeo/reducer'
import { EmptyState } from '../../common/components/EmptyState/EmptyState'
import { Typography } from '@mui/material'
import { SEO_CLOUD_MARKETPLACE } from './seoCloud'
import { SeoCloudSelector } from './SeoCloudSelector'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPaperPlaneTop,
  faSparkles,
  faArrowUpRightFromSquare,
} from '@fortawesome/pro-regular-svg-icons'
import { faLightbulb } from '@fortawesome/free-regular-svg-icons'
import { TipsAndImprovementSidePanel } from './TipsAndImprovementSidePanel/TipsAndImprovementSidePanel'
import { tipsSidePanelData } from './tipsAndImprovementData'
import { AddEditKeywords } from './AddEditKeywords/AddEditKeywords'
import KeywordDashboard from './KeywordDashboard/KeywordDashboard'
import AiModalContent from './AiModal/AiModalContent'
import { getProductsWithListing } from '../../modules/productsListing/action'
import { Product } from '../../modules/productsListing/types'
import { isEmpty } from 'lodash'
import AiGeneratedModal from './AiGeneratedModal/AiGeneratedModal'
import { TipsButton } from './TipsButton'

export type Competitor = {
  id: string
  competitorName: string
  data: {
    date: string
    rank: number
    id: string
    product_name: string
    listing_url?: string
  }[]
}

export type Keyword = {
  id: string
  name: string
  updatedAt: string
  data: Competitor[]
}

export const SearchRankingV2 = () => {
  const { classes } = useStyles()
  const dispatch = useDispatch()
  const accountId = useSeoAccountId()
  const selectedCloud = SEO_CLOUD_MARKETPLACE
  const [selectedListing, setSelectedListing] = useState<Product>()
  const [selectedSearchKeyWords, setSelectedSearchKeyWords] = useState()
  const [generateButtonEnabled, setGenerateButtonEnabled] = useState(false)
  const [updateContentButtonDisabled, setUpdateButtonDisabled] = useState(false)
  const handleSelectedListingData = useCallback((data: Product) => {
    setSelectedListing(data)
  }, [])
  const [selectedSearchKeywordsSelection, setSelectedSearchKeywordsSelection] =
    useState(selectedSearchKeyWords)
  const [selectedListingSelection, setSelectedListingSelection] =
    useState<Product>()

  const handleSelectedSearchKeywords = useCallback((keywords: any) => {
    setSelectedSearchKeyWords(keywords)
  }, [])
  const handleGeneratButtonState = useCallback((value: boolean) => {
    setGenerateButtonEnabled(value)
  }, [])
  const handleContentButtonDisabled = useCallback((value: boolean) => {
    setUpdateButtonDisabled(value)
  }, [])
  const productWithListingData = useSelector<Product[]>(
    state =>
      state.productsListing[selectedCloud]?.productWithListingData?.rows || []
  )

  useEffect(() => {
    if (accountId && selectedCloud && isEmpty(productWithListingData)) {
      dispatch(getProductsWithListing(accountId, selectedCloud))
    }
  }, [accountId, selectedCloud])
  const [openCompetitorAndKeywords, setOpenCompetitorAndKeywords] =
    useState(false)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [openAiModal, setOpenAiModal] = useState(false)
  const [openAiGeneratedModal, setOpenAiGeneratedModal] = useState(false)
  const [openListingSaveModal, setOpenListingSaveModal] = useState(false)
  const [getData, setGetData] = useState(false)

  const handleFormChange = useCallback((_formikData: unknown) => {
    void _formikData
  }, [])
  const handleCloseAiModal = () => {
    setSelectedSearchKeyWords([] as any)
    setSelectedListing('' as any)
    setOpenAiModal(false)
  }
  const handleCloseAiGenerateModal = () => {
    setSelectedSearchKeyWords([] as any)
    setSelectedListing('' as any)
    setOpenAiGeneratedModal(false)
    setGetData(false)
  }

  const handleListingCloseSaveModal = () => {
    setOpenListingSaveModal(false)
  }
  const { classes: styles } = useStyles()
  const openDrawer = () => {
    setIsOpen(true)
  }
  const toggleDrawer = async () => {
    setIsOpen(false)
  }
  const handleAcceptAiGeneratedModal = () => {
    setOpenListingSaveModal(true)
    setGetData(true)
  }

  const isLoadingSearchSeo = useSelector<boolean>(state =>
    Loading(state.loading)(LoadingTypes.SEARCH_SEO_RANKING)
  )
  const isLoadingAccounts = useSelector<boolean>(state =>
    Loading(state.loading)(LoadingTypes.LOAD_AVAILABLE_ACCOUNTS)
  )
  const isLoadingGenerateButton = useSelector<boolean>(state =>
    Loading(state.loading)(LoadingTypes.GENERATE_AI_LOADING)
  )

  const searchKeywordRanking = useSelector<KeywordItem[]>(
    state => state.marketplaceSeo[selectedCloud].keywordRanking
  )
  const isEmptySearchRanking = !searchKeywordRanking?.length

  useEffect(() => {
    if (accountId && selectedCloud) {
      dispatch(getKeywords(accountId, selectedCloud))
      dispatch(getSelfListingUrl(accountId, selectedCloud))
      dispatch(getCompetitors(accountId, selectedCloud))
      dispatch(searchRanking(accountId, selectedCloud))
    }
  }, [accountId, selectedCloud])

  const manageRankTraking = (
    <ButtonV2 smallVariant onClick={() => setOpenCompetitorAndKeywords(true)}>
      Manage keywords and competitors
    </ButtonV2>
  )
  const generateAiContent = async () => {
    await dispatch(
      generateContentAi(accountId, {
        data: selectedListing,
        keywords: selectedSearchKeyWords,
      })
    )
  }
  const handleAcceptAiModal = async () => {
    await generateAiContent()
    setSelectedSearchKeywordsSelection(selectedSearchKeyWords)
    setSelectedListingSelection(selectedListing)
    setOpenAiModal(false)
    setOpenAiGeneratedModal(true)
  }
  const contentAIButton = (
    <ButtonV2
      smallVariant
      styleType="outlined"
      icon={<FontAwesomeIcon icon={faSparkles} />}
      onClick={() => setOpenAiModal(true)}
      className={classes.aiButtonColor}
    >
      Write content with AI
    </ButtonV2>
  )

  const rightHeaderAction = (
    <div className={classes.buttonWrapper} data-testid="button-wrapper-seo">
      {!isEmptySearchRanking && <TipsButton openDrawer={openDrawer} />}
      <div className={classes.rightButtonWrapper}>
        <div className={classes.cloudWrapper}>
          <SeoCloudSelector />
        </div>
        {!isEmptySearchRanking && contentAIButton}
        {manageRankTraking}
      </div>
    </div>
  )

  if (isLoadingSearchSeo || (isLoadingAccounts && !accountId)) {
    return <LoadingLogo />
  }
  const handleAiModalOpen = async () => {
    setSelectedListing(selectedListingSelection)
    setSelectedSearchKeyWords(selectedSearchKeywordsSelection)
    setOpenAiModal(true)
  }
  return (
    <div data-testid={'search-ranking-v2'}>
      {!isEmptySearchRanking && (
        <div className={classes.headerContainer}>{rightHeaderAction}</div>
      )}

      {isEmptySearchRanking && (
        <div className={classes.emptyState}>
          <EmptyState
            action={rightHeaderAction}
            content={
              <>
                <div className={classes.subHeadingContainer}>
                  <Typography className={classes.subHeading}>
                    Monitor your listings rank, content and always be a step
                    ahead of your competitors.
                  </Typography>
                  <Typography className={classes.subHeading}>
                    Start by adding your competitors and keywords to compare
                    search rankings on the AWS marketplace.
                  </Typography>
                </div>
              </>
            }
            header="Start tracking your first keyword"
            imgSrc={EmptyProductListing}
          />
        </div>
      )}
      {openCompetitorAndKeywords && (
        <AddEditKeywords
          openKeyword={openCompetitorAndKeywords}
          setOpenKeyword={setOpenCompetitorAndKeywords}
          title={'Manage keywords and competitors'}
        />
      )}
      {!isEmptySearchRanking && (
        <div className={classes.wrapper}>
          <KeywordDashboard keywords={searchKeywordRanking} />
        </div>
      )}
      <SidePanelInfo
        icon={
          <FontAwesomeIcon
            icon={faLightbulb}
            style={{ width: '24px', height: '24px', fontSize: '24px' }}
          />
        }
        headerTitle={
          <div className={classes.title}>{tipsSidePanelData.title}</div>
        }
        open={isOpen}
        onClose={toggleDrawer}
        content={
          <div className={classes.aiParentWrapper}>
            <TipsAndImprovementSidePanel content={tipsSidePanelData.content} />
            <div className={styles.horizontalDivider}></div>
            <div className={classes.aiWrapper}>
              <Typography className={classes.sidepanelText}>
                Apply the above mentioned tips to your product listing to
                improve ranking with the help of AI generated content.
              </Typography>
              <div style={{ width: 'fit-content' }}>{contentAIButton}</div>
            </div>
          </div>
        }
      />

      {/* modal */}
      {openAiModal && (
        <ModalConfirmV2
          title={' Write content with AI'}
          content={
            <div>
              <AiModalContent
                handleSelectedListingData={handleSelectedListingData}
                handleGeneratButtonState={handleGeneratButtonState}
                handleSelectedSearchKeywords={handleSelectedSearchKeywords}
                selectedListingProduct={selectedListing as Product}
                selectedSearchKeyWords={selectedSearchKeyWords}
              />
            </div>
          }
          hideCancelButton={false}
          open={openAiModal}
          hideAcceptButton={false}
          titleAcceptButton={'Generate Content'}
          onDecline={handleCloseAiModal}
          onAccept={handleAcceptAiModal}
          acceptDisabled={!generateButtonEnabled}
          variant={ModalSizeVariants.large}
          acceptLoading={isLoadingGenerateButton}
          icon={
            <FontAwesomeIcon style={{ height: '14px' }} icon={faSparkles} />
          }
        />
      )}
      {openAiGeneratedModal && (
        <ModalConfirmV2
          title={'Write content with AI'}
          content={
            <div className={classes.scrollWrapper}>
              <AiGeneratedModal
                selectedListing={selectedListing as Product}
                selectedListingSelection={selectedListingSelection as Product}
                selectedSearchKeyWords={selectedSearchKeyWords}
                handleSelectedSearchKeywords={handleSelectedSearchKeywords}
                selectedSearchKeywordsSelection={
                  selectedSearchKeywordsSelection
                }
                handleAiModalOpen={handleAiModalOpen}
                handleFormChange={handleFormChange}
                getData={getData}
                handleContentButtonDisabled={handleContentButtonDisabled}
                handleCloseModal={handleCloseAiGenerateModal}
              />
            </div>
          }
          hideCancelButton={false}
          open={openAiGeneratedModal}
          hideAcceptButton={false}
          titleAcceptButton={'Continue'}
          onDecline={handleCloseAiGenerateModal}
          onAccept={handleAcceptAiGeneratedModal}
          acceptDisabled={!updateContentButtonDisabled}
          variant={ModalSizeVariants.large}
          fullScreen={true}
          icon={
            <FontAwesomeIcon style={{ height: '14px' }} icon={faSparkles} />
          }
        />
      )}

      {openListingSaveModal && (
        <ModalConfirmV2
          title={`Copy AI-Generated Content`}
          content={
            <Typography className={classes.modalHeading}>
              Copy the generated content, then go to your listing's{' '}
              <a
                href={`https://${getUrlPrefix(serviceEnvironment)}app.labra.io/flyout/${selectedCloud.toLowerCase()}/${accountId}/products-listing/${selectedListing?.id}/details`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '4px',
                }}
              >
                edit page
                <FontAwesomeIcon
                  icon={faArrowUpRightFromSquare}
                  style={{ height: '12px', width: '12px' }}
                />
              </a>{' '}
              and paste it into the appropriate section to update your listing.
            </Typography>
          }
          hideCancelButton={true}
          open={openListingSaveModal}
          hideAcceptButton={false}
          titleAcceptButton={'Ok'}
          onDecline={handleListingCloseSaveModal}
          onAccept={handleListingCloseSaveModal}
          variant={ModalSizeVariants.small}
          titleCancelButton={'Discard'}
          icon={
            <FontAwesomeIcon
              style={{ height: '14px' }}
              icon={faPaperPlaneTop}
            />
          }
        />
      )}
    </div>
  )
}
